import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import 'css-loader/dist/runtime/api.js'
import 'vue-style-loader/lib/addStylesShadow'
import 'vue-loader/lib/runtime/componentNormalizer'

window.customElements.define('recomponents-r-avatar', wrap(Vue, () => import('~root/src/components/r-avatar/r-avatar.vue?shadow')))

window.customElements.define('recomponents-r-badge', wrap(Vue, () => import('~root/src/components/r-badge/r-badge.vue?shadow')))

window.customElements.define('recomponents-r-button', wrap(Vue, () => import('~root/src/components/r-button/r-button.vue?shadow')))

window.customElements.define('recomponents-r-button-group', wrap(Vue, () => import('~root/src/components/r-button-group/r-button-group.vue?shadow')))

window.customElements.define('recomponents-r-checkbox', wrap(Vue, () => import('~root/src/components/r-checkbox/r-checkbox.vue?shadow')))

window.customElements.define('recomponents-r-calendar-manager', wrap(Vue, () => import('~root/src/components/r-date-input/r-calendar-manager.vue?shadow')))

window.customElements.define('recomponents-r-date-input', wrap(Vue, () => import('~root/src/components/r-date-input/r-date-input.vue?shadow')))

window.customElements.define('recomponents-r-date-range-button-group', wrap(Vue, () => import('~root/src/components/r-date-input/r-date-range-button-group.vue?shadow')))

window.customElements.define('recomponents-r-file-upload', wrap(Vue, () => import('~root/src/components/r-file-upload/r-file-upload.vue?shadow')))

window.customElements.define('recomponents-r-grid', wrap(Vue, () => import('~root/src/components/r-grid/r-grid.vue?shadow')))

window.customElements.define('recomponents-r-icon', wrap(Vue, () => import('~root/src/components/r-icon/r-icon.vue?shadow')))

window.customElements.define('recomponents-r-icon-button', wrap(Vue, () => import('~root/src/components/r-icon-button/r-icon-button.vue?shadow')))

window.customElements.define('recomponents-r-img', wrap(Vue, () => import('~root/src/components/r-img/r-img.vue?shadow')))

window.customElements.define('recomponents-r-input', wrap(Vue, () => import('~root/src/components/r-input/r-input.vue?shadow')))

window.customElements.define('recomponents-r-loader', wrap(Vue, () => import('~root/src/components/r-loader/r-loader.vue?shadow')))

window.customElements.define('recomponents-r-modal', wrap(Vue, () => import('~root/src/components/r-modal/r-modal.vue?shadow')))

window.customElements.define('recomponents-r-month-picker-input', wrap(Vue, () => import('~root/src/components/r-month-picker/r-month-picker-input.vue?shadow')))

window.customElements.define('recomponents-r-month-picker', wrap(Vue, () => import('~root/src/components/r-month-picker/r-month-picker.vue?shadow')))

window.customElements.define('recomponents-r-pagination', wrap(Vue, () => import('~root/src/components/r-pagination/r-pagination.vue?shadow')))

window.customElements.define('recomponents-r-pagination-control', wrap(Vue, () => import('~root/src/components/r-pagination-control/r-pagination-control.vue?shadow')))

window.customElements.define('recomponents-r-popper', wrap(Vue, () => import('~root/src/components/r-popper/r-popper.vue?shadow')))

window.customElements.define('recomponents-r-radio', wrap(Vue, () => import('~root/src/components/r-radio/r-radio.vue?shadow')))

window.customElements.define('recomponents-r-repeater', wrap(Vue, () => import('~root/src/components/r-repeater/r-repeater.vue?shadow')))

window.customElements.define('recomponents-r-select', wrap(Vue, () => import('~root/src/components/r-select/r-select.vue?shadow')))

window.customElements.define('recomponents-r-tab', wrap(Vue, () => import('~root/src/components/r-tabs/r-tab.vue?shadow')))

window.customElements.define('recomponents-r-tabs', wrap(Vue, () => import('~root/src/components/r-tabs/r-tabs.vue?shadow')))

window.customElements.define('recomponents-r-tile', wrap(Vue, () => import('~root/src/components/r-tile/r-tile.vue?shadow')))

window.customElements.define('recomponents-r-toast', wrap(Vue, () => import('~root/src/components/r-toast/r-toast.vue?shadow')))

window.customElements.define('recomponents-r-toggle', wrap(Vue, () => import('~root/src/components/r-toggle/r-toggle.vue?shadow')))

window.customElements.define('recomponents-r-webcomponent', wrap(Vue, () => import('~root/src/components/r-webcomponent/r-webcomponent.vue?shadow')))

window.customElements.define('recomponents-badge', wrap(Vue, () => import('~root/src/components/r-grid/columnTypes/badge.vue?shadow')))

window.customElements.define('recomponents-text', wrap(Vue, () => import('~root/src/components/r-grid/columnTypes/text.vue?shadow')))